import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-questionnaire',
  templateUrl: './edit-questionnaire.component.html',
  styleUrls: ['./edit-questionnaire.component.css']
})
export class EditQuestionnaireComponent implements OnInit, OnDestroy {
  public editquesionform: FormGroup;
  queNumber1: any;
  QuestionArrData: any = [];
  viewQuestionnaire: any = [];
  questionnareid: any;
  programTitle: any;
  viewQuestionnaireData: Subscription | any;

  constructor(public service: MainService, private fb: FormBuilder, private activatedroute: ActivatedRoute,
    private router: Router) {
    this.editquesionform = fb.group({
      'QuestionType': [''],
      'QueArr1': fb.array([])
    });
    this.activatedroute.params.subscribe((res) => {
      this.questionnareid = res.id
    })
  }

  ngOnInit() {
    this.viewQuestionaire(this.questionnareid)
  }

  viewQuestionaire(id: any) {
    this.viewQuestionnaireData = this.service.getApi(ApiUrls.viewQuestionnaire + `?questionnaireId=${id}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.programTitle = res.result.programId.title
        this.viewQuestionnaire = res.result.Questions;
        if (this.viewQuestionnaire) {
          this.viewQuestionnaire.forEach((ele: any) => {
            this.addUser1(ele)
          });
        }
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  addUser1(QueArr?: any, i?: any) {
    this.queNumber1 = this.queNumber1 + 1;
    let fg = this.fb.group({
      'QuestionText': [QueArr ? QueArr.QuestionText : '', Validators.compose([Validators.required])],
      'QuestionTextFR': [QueArr ? QueArr.QuestionTextFR : ''],
      'QuestionTextES': [QueArr ? QueArr.QuestionTextES : ''],
      'QuestionType': [QueArr ? QueArr.QuestionType : '', Validators.compose([Validators.required])],
      'options': this.fb.array([])
    });
    (<FormArray>this.editquesionform.get('QueArr1')).push(fg);
    let userIndex = (<FormArray>this.editquesionform.get('QueArr1')).length - 1;
    if (!QueArr) {
      this.addOption1(userIndex);
    }
    else {
      QueArr.options.forEach((option: any) => {
        this.addOption1(userIndex, option);
      });
    }
  }

  addOption1(userIndex: number, data?: any) {
    let fg: any = this.fb.group({
      'option': data && data.option ? data.option : '',
      'optionFR': data && data.optionFR ? data.optionFR : '',
      'optionES': data && data.optionES ? data.optionES : ''
    });
    (<FormArray>(<FormGroup>(<FormArray>this.editquesionform.controls['QueArr1']).controls[userIndex]).controls['options']).push(fg);
  }

  deleteOption1(userIndex: number, index: number) {
    (<FormArray>(<FormGroup>(<FormArray>this.editquesionform.controls['QueArr1'])
      .controls[userIndex]).controls['options']).removeAt(index);
  }

  deleteUser1(index: number) {
    (<FormArray>this.editquesionform.get('QueArr1')).removeAt(index);
  }

  editQuestionnaireApi() {
    let flag = true;
    this.editquesionform.value.QueArr1.forEach((element: any) => {
      if (element.QuestionType == '') {
        this.QuestionArrData = [];
        this.service.warningToast('Please select the question type');
        flag = false;
        return;
      }
      if (element.QuestionText == '') {
        this.QuestionArrData = [];
        this.service.warningToast('Please type your question');
        flag = false;
        return;
      }
    });
    if (flag) {
      if (this.editquesionform.value.QueArr1.length > 0) {
        this.editquesionform.value.QueArr1.forEach((ele: any, index: number) => {
          if (this.QuestionArrData.length >= 0) {
            if (ele.QuestionType !== "checkbox") {
              ele['options'] = [
                {
                  'option': "",
                  'optionsFR': "",
                  'optionsES': ""
                }
              ];
            }
            ele['QuestionNumber'] = index + 1;
            this.QuestionArrData.push(ele);
          }
        });
      } else {
        this.QuestionArrData = this.editquesionform.value.QueArr1[0];
      }

      if (this.editquesionform.valid) {
        const data = {
          Questions: this.QuestionArrData
        }
        this.service.showSpinner();
        this.service.putApi(ApiUrls.editQuestionnaire + `?questionnaireId=${this.questionnareid}`, data, 1).subscribe((res) => {
          this.service.hideSpinner();
          if (res.responseCode === 200) {
            this.QuestionArrData = [];
            this.service.successToast(res.responseMessage);
            const data1 = {
              tabView: "Questionnaire",
              acion: "view"
            }
            this.router.navigate(['assessment'], { queryParams: { value: JSON.stringify(data1) } })
          }
          else {
            this.service.errorToast(res.responseMessage)
          }

        }, err => {
          this.service.hideSpinner();
          this.service.errorToast(err.responseMessage)
        })
      }
      else {
        // this.QuestionArrData = [];
        this.service.errorToast('Please fill the all the details');
      }
    }

  }

  ngOnDestroy() {
    this.viewQuestionnaireData.unsubscribe()
  }
}
